import {Injectable}     from 'angular2/core';
import {Http, Response} from 'angular2/http';
import {Observable}     from 'rxjs/Observable';
import {Voucher}        from "../../models/voucher.model";
import {App}            from "../../app_config";
import {CustomBaseRequestOptions} from "../../http/custom_base_request_options";
import {AbstractService} from "../abstract.service";

@Injectable()
export class VoucherService extends AbstractService {

    constructor(private http:Http) {
        super();
    }

    private _voucherUrl = App.AppConfig.apiEndPoint + '/code';

    getVouchers(campaignId:string, page:number, perPage:number, searchQuery:string):Observable<Voucher[]> {
        searchQuery = searchQuery === "" ? "*" : searchQuery;
        page = page - 1;
        return this.http.get(this._voucherUrl + "/list/" + campaignId + "/" + searchQuery + "/" + perPage + "/" + page)
            .map(this.extractData)
            .map(vouchers => vouchers.map(voucher => new Voucher(voucher)))
            .catch(this.handleError);

    }

    count(campaignId:string, searchQuery:string):Observable<number> {
        searchQuery = searchQuery === "" ? "*" : searchQuery;
        return this.http.get(this._voucherUrl + "/" + campaignId + "/" + searchQuery + "/count").map(response => response.json());
    }

    getVoucher(code:string):Observable<Voucher> {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.get(this._voucherUrl + "/" + code, options)
            .map(response => response.json())
            .map(campaign => new Voucher(campaign))
            .catch(this.handleError);
    }

    destroyVoucher(code:string) {
        let options = new CustomBaseRequestOptions();
        options.headers.set('Content-Type', 'application/json');
        return this.http.delete(this._voucherUrl + "/" + code + "/delete", options)
            .catch(this.handleError);
    }

    private extractData(res:Response) {
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }
        let body = res.json();
        return body.vouchers || {};
    }
}
